import { render, staticRenderFns } from "./wagesTemplate.vue?vue&type=template&id=655da348&scoped=true&"
import script from "./wagesTemplate.vue?vue&type=script&lang=js&"
export * from "./wagesTemplate.vue?vue&type=script&lang=js&"
import style0 from "./wagesTemplate.vue?vue&type=style&index=0&id=655da348&scoped=true&lang=css&"
import style1 from "./wagesTemplate.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655da348",
  null
  
)

export default component.exports